import { WrapMdMarginBottom } from "App/global-style";
import styled from "styled-components";

export const SummarySum = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.xl};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  line-height: ${({ theme }) => theme.lineHeight.xl};
`;

export const SummaryWrapper = styled(WrapMdMarginBottom)`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-top: ${({ theme }) => theme.spacing.md};
`;

export const SummaryText = styled.p`
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  text-align: center;
`;
